import { Component, forwardRef, OnDestroy } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, Validator, NG_VALIDATORS, FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { emailPattern, splitPattern } from '../../shared/constants';

@Component({
	selector: 'app-mail-form',
	templateUrl: './mail-form.component.html',
	styleUrl: './mail-form.component.css',
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => MailFormComponent),
			multi: true
		}
	]
})
export class MailFormComponent implements ControlValueAccessor, Validator, OnDestroy {
	form: FormGroup;
	private subs: Subscription[] = [];
	onChange = (_: any) => { };
	onTouched = () => { };
	public emailvalidators: any = [this.emailPatternValidator];
	public emailerrormessages = { 'emailerr': 'Please enter valid email-id' };
	emailPatternValidator(control: FormControl) {
		const regex = emailPattern;
		if (!control.value.match(regex)) {
			return {
				'emailerr': true
			};
		}
		return null;
	};
	quillConfig = {
		toolbar: {
			container: [
				['bold', 'italic', 'underline'],
				[{ 'list': 'ordered' }, { 'list': 'bullet' }],
				[{ 'header': [1, 2, 3, 4, 5, 6, false] }],
				[{ 'color': [] }, { 'background': [] }],
				[{ 'font': [] }],
				[{ 'align': [] }]
			]
		}
	};
	splitPattern = splitPattern;

	constructor(private fb: FormBuilder) {
		this.form = this.fb.group({
			toMail: [null, Validators.required],
			ccMail: [null],
			bccMail: [null],
			subject: [null, Validators.required],
			body: [null, Validators.required]
		});
		this.subs.push(
			this.form.valueChanges.subscribe(v => {
				this.onChange(v);
				this.onTouched();
			})
		);
	}

	writeValue(obj: any): void {
		if (obj) {
			this.form.patchValue(obj, { emitEvent: false });
		} else {
			this.form.reset({
				toMail: null,
				ccMail: null,
				bccMail: null,
				subject: null,
				body: null
			}, { emitEvent: false });
		}
	}

	registerOnChange(fn: any): void { this.onChange = fn; }
	registerOnTouched(fn: any): void { this.onTouched = fn; }

	validate(): null | { nameInvalid: true } {
		return this.form.valid ? null : { nameInvalid: true };
	}

	ngOnDestroy() {
		this.subs.forEach(s => s.unsubscribe());
	}
}
